import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import InsuranceTypes from "@/components/InsuranceTypes";
import HowItWorks from "@/components/HowItWorks";
import AboutDarryl from "@/components/AboutDarryl";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import CtaBanner from "@/components/CtaBanner";

export default function Landing() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <InsuranceTypes />
        <HowItWorks />
        <AboutDarryl />
        <FAQ />
        <CtaBanner />
      </main>
      <Footer />
    </>
  );
}
